import script from "./SelectorWidget.vue?vue&type=script&lang=js"
export * from "./SelectorWidget.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__